import Yup, { ValidationError } from "yup";
import { FormikErrors, FormikTouched, setIn } from "formik";

type SectionValidityArgs<T> = {
    stepName: string;
    values: T;
    schema: Yup.Schema<any>;
    formik: {
        setErrors: (errors: FormikErrors<T>) => void;
        setTouched: (touched: FormikTouched<T>) => void;
        setFieldError: (field: string, message: string) => void;
        touched: FormikTouched<T>;
        errors: FormikErrors<T>;
    };
};

export const checkStepValidity = async <T extends object>(
    args: SectionValidityArgs<T>
): Promise<boolean> => {
    const { stepName, schema, values, formik } = args;
    let stepFieldErrors = {};
    let stepFieldTouched = {};

    const setError = (error: ValidationError) => {
        const shortPath = error.path.substring(stepName.length + 1);
        stepFieldErrors = setIn(stepFieldErrors, shortPath, error.message);
        stepFieldTouched = setIn(stepFieldTouched, shortPath, true);
    };

    try {
        await schema.validateAt(stepName, values, { abortEarly: false });
        formik.setFieldError(stepName, undefined);
        return true;
    } catch (err) {
        if (err instanceof ValidationError) {
            if (!err.inner || err.inner.length === 0) {
                setError(err);
            } else {
                err.inner.forEach(setError);
            }

            formik.setErrors({
                ...formik.errors,
                [stepName]: stepFieldErrors,
            });

            formik.setTouched({
                ...formik.touched,
                [stepName]: stepFieldTouched,
            });
        }
        return false;
    }
};
